import { render, staticRenderFns } from "./TextHighlight.vue?vue&type=template&id=3a769b85&"
import script from "./TextHighlight.vue?vue&type=script&lang=js&"
export * from "./TextHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports